import { Mascot } from "@/components/game/Mascot";

const SIZES = { fill: "h-full w-full text-[2.2vh]", vh: "h-[6vh] w-[6vh] text-[2.4vh]", xl: "h-20 w-20 text-3xl", lg: "h-16 w-16 text-2xl", sm: "h-8 w-8 text-xs", md: "h-12 w-12 text-lg" };

export const InitialDot = ({ color, initials, mascot, size = "md" }) => {
  const cls = SIZES[size] || SIZES.md;
  if (mascot) {
    return (
      <div className={`${cls} rounded-full grid place-items-center shrink-0 bg-[#111722] border-2`} style={{ borderColor: color, boxShadow: `0 0 18px ${color}55` }}>
        <Mascot id={mascot} size="86%" />
      </div>
    );
  }
  return (
    <div className={`${cls} rounded-full grid place-items-center font-display font-bold text-[#0B0F16] shrink-0`} style={{ backgroundColor: color, boxShadow: `0 0 18px ${color}88` }}>
      {initials}
    </div>
  );
};

export const EmptySeat = ({ big, fill }) => <div className={`${fill ? "h-full w-full" : big ? "h-[6vh] w-[6vh]" : "h-12 w-12"} rounded-full border-2 border-dashed border-slate-500/35`} />;

export const teamById = (teams, id) => teams.find((t) => t.id === id);
